const PX_WIDTH = /^\d+(?:\.\d+)?px$/;

const hasWidth = (col: Element) =>
  PX_WIDTH.test((col as HTMLElement).style.width) ||
  /^\d+$/.test(col.getAttribute('width') ?? '');

/** 표 import 는 너비 없는 col 이 하나라도 있으면 열 너비 전체를 버려, 끝쪽 빈 col 만 제거 */
const trimUnsizedTrailingCols = (doc: Document) => {
  doc.querySelectorAll('table > colgroup').forEach((colGroup) => {
    const cols = Array.from(colGroup.querySelectorAll(':scope > col'));
    if (!cols.some(hasWidth)) return;
    for (let i = cols.length - 1; i >= 0 && !hasWidth(cols[i]); i -= 1) {
      cols[i].remove();
    }
  });
};

export default trimUnsizedTrailingCols;
